import { GridActionsCellItem } from "@mui/x-data-grid-pro";

interface Props {
  label: string;
  rowAction?: (row: any) => void;
  icon: any;
}

export const GridActionCell = ({ label, rowAction, icon }: Props) => (
  <GridActionsCellItem
    icon={icon}
    label={label}
    onClick={rowAction}
    color="inherit"
  />
);
